<form [formGroup]="endpointForm">
  <div class="row">
    <div class="col-6">
      <label for="keyword" [ngbTooltip]="constants.newEndpointKeyword">Keyword</label>
      <input type="text" class="form-control form-control-sm" formControlName="keywords" id="keywords">
    </div>
    <div class="col-6">
      <label class="font-bold" [ngbTooltip]="constants.newEndpointThreshold">Threshold (in seconds)</label>
      <input type="number" min="0" class="form-control form-control-sm" formControlName="threshold" id="threshold">
    </div>

  </div>

  <div class="row mt-4">
    <div class="col-4" style="display: flex;border-right: 3px dotted grey;">
      <div style="width: 85%">
        <label for="environment-specific" class="font-bold">Environment specific</label> <a [routerLink]="['/user/environment-management']" target="_blank" *ngIf="endpointForm.value?.environmentSpecific"><i class="fab fa-cloudversify ml-1 text-primary" title="Add/View Environment" style="font-size:large;"></i></a>
        <small id="envspecificYes" class="form-text text-muted" *ngIf="endpointForm.value?.environmentSpecific">{{constants.newEndpointSpecificYes}}</small>
        <small id="envspecificNo" class="form-text text-muted" *ngIf="endpointForm.value?.environmentSpecific === false">{{constants.newEndpointSpecificNo}}</small>
      </div>
      <ui-switch class="mt-4" formControlName="environmentSpecific" id="env-specific"></ui-switch>
    </div>
    <div class="col-4" style="display: flex;border-right: 3px dotted grey;">
      <div style="width: 85%">
        <label for="follow-redirects">Automatically follow redirect </label>
        <small id="autoredirect" class="form-text text-muted" >{{constants.newEndpointAutoRedirect}}</small>
      </div>
      <ui-switch class="mt-4" formControlName="followRedirects" id="follow-redirects"></ui-switch>
    </div>
    <div class="col-4" style="display: flex">
      <div style="width: 85%">
        <label for="sanitize-json">Sanitize Json Response </label>
        <small id="sanitizeres" class="form-text text-muted" >{{constants.newEndpointSanitizeJson}}</small>
      </div>
      <ui-switch class="mt-4" formControlName="sanitizeJsonResponse" id="sanitize-json"></ui-switch>
    </div>

  </div>

  <!-- Configure section -->
  <div class="new-section">
    <h4 class="">Configure</h4>
    <div class="row">
      <div class="col-2">
        <label for="">Type <span class="text-danger">*</span></label>
        <select class="form-control form-control-sm" [class.is-invalid]="submitted && f.requestType.errors"
          [class.is-valid]="submitted && !f.requestType.errors" name="requestSelect" id="request-type"
          formControlName="requestType">
          <option value="">Select</option>
          <option *ngFor="let item of this.configure.requestTypes" [value]="item">{{item}}</option>
        </select>
      </div>
      <div class="col">
        <label for="path">Path <span class="text-danger">*</span></label>
        <input type="text" class="form-control form-control-sm" [class.is-invalid]="submitted && f.uri.errors"
          [class.is-valid]="submitted && !f.uri.errors" formControlName="uri" id="path" name="uri" [placeholder]="endpointForm?.value?.environmentSpecific ? 'Example : /relay-api/endPoints/onboard/{{api}}/count' : 'Example : https://relay-stage.corp.adobe.com/#relay/endpoint/new'">
      </div>
      <div class="col-2">
        <label for="response-type">Select Response <span class="text-danger">*</span></label>
        <select class="form-control form-control-sm" name="requestSelect" id="response-type"
          formControlName="responseType" (change)="onResponseTypeChange()" [class.is-invalid]="submitted && f.responseType.errors"
          [class.is-valid]="submitted && !f.responseType.errors">
          <option value="">Select</option>
          <option *ngFor="let item of this.configure.responseTypes" [value]="item">{{item}}</option>
        </select>
      </div>
    </div>
    <div class="row mt-2" *ngIf="selectedResponseType === 'EVENT_STREAM'">
      <div class="col-6">
        <label for="timeout">Event Stream Timeout (In Sec) </label>
        <input type="number" min="0" class="form-control form-control-sm" formControlName="eventStreamTimeout" id="timeout" name="timeout" placeholder="Event Stream Time">
      </div>
      <div class="col-6">
        <label for="interruptkey">Event Stream Interrupt Keyword</label>
        <input type="text" class="form-control form-control-sm" formControlName="eventStreamInterruptKeyword" id="interruptkey" name="interruptkey" placeholder="Interrupt Key">
      </div>
    </div>

    <!-- Tab section -->
    <div class="mt-3">
      <ul ngbNav #nav="ngbNav" [activeId]="activeTabId" class="nav-tabs">
        <li title="AUTHORIZATION" id="0" [ngbNavItem]="0" formGroupName="authorization">
          <a ngbNavLink [ngbTooltip]="constants.newEndpointAuthorization">AUTHORIZATION</a>
          <ng-template ngbNavContent>
            <div class="row mt-3">
              <div class="col-3">
                <label for="auth-type" [ngbTooltip]="endpointForm.value.authorization.authorizationType === 'BASIC_AUTH' ? constants.newEndpointAuthorizationBasicAuth : constants.newEndpointAuthorizationNone">Auth Type: <span class="text-danger">*</span></label>
                <select id="auth-type" name="authorizationType" class="form-control form-control-sm"
                  [class.is-invalid]="submitted && endpointForm.get('authorization.authorizationType').errors"
                  [class.is-valid]="submitted && !endpointForm.get('authorization.authorizationType').errors"
                  formControlName="authorizationType">
                  <option value="">Select</option>
                  <option value="NONE">NONE</option>
                  <option value="BASIC_AUTH">Basic Auth</option>
                  <option value="TWO_WAY_SSL" *ngIf="endpointForm.value.defaultAuthorizationType === 'TWO_WAY_SSL'">Two
                    Way SSL</option>
                </select>
              </div>

              <div class="col-6" *ngIf="endpointForm.value.authorization.authorizationType === 'BASIC_AUTH'">
                <div class="row">
                  <div class="col-4">
                    <label for="auth-username">User name</label>
                    <input type="text" id="auth-username" class="form-control form-control-sm"
                      formControlName="username" placeholder="User name">
                  </div>
                  <div class="col-4">
                    <label for="auth-pass">Password</label>
                    <input type="password" id="auth-pass" class="form-control form-control-sm"
                      formControlName="password" placeholder="Password">
                  </div>
                </div>

              </div>
            </div>
          </ng-template>
        </li>
        <li title="HEADERS" id="1" [ngbNavItem]="1">
          <a ngbNavLink [ngbTooltip]="constants.newEndpointHeader">HEADERS</a>
          <ng-template ngbNavContent>
            <div class="mt-3">
              <div class="form-check form-check-inline">
                <input class="form-check-input" id="header-key-value" name="header-key-value" type="radio"
                  (change)="changeEditOptions('headerEditOption','requestHeadersBulk','requestHeaders')"
                  [(ngModel)]="headerEditOption" [ngModelOptions]="{standalone: true}" value="keyval">
                <label class="form-check-label" for="header-key-value" [ngbTooltip]="constants.newEndpointHeaderKey">Key value</label>
              </div>

              <div class="form-check form-check-inline">
                <input class="form-check-input" id="header-bulk" name="header-bulk" type="radio"
                  (change)="changeEditOptions('headerEditOption','requestHeadersBulk','requestHeaders')"
                  [(ngModel)]="headerEditOption" [ngModelOptions]="{standalone: true}" value="bulk">
                <label class="form-check-label" for="header-bulk" [ngbTooltip]="constants.newEndpointHeaderBulk">Bulk</label>
              </div>
              <hr>
            </div>

            <!-- Key value section -->
            <div *ngIf="headerEditOption === KEYVAL">
              <div class="table-responsive">
                <table class="table table-bordered table-sm">
                  <thead class="thead-dark">
                    <tr>
                      <th width="20%">Key</th>
                      <th>Value</th>
                      <th width="5%"></th>
                    </tr>
                  </thead>
                  <tr>
                    <td><input type="text" placeholder="Enter key" id="header-key" name="header-key"
                        class="form-control form-control-sm" [(ngModel)]="headers.key"
                        [ngModelOptions]="{standalone: true}"></td>
                    <td><input type="text" placeholder="Enter values" id="header-value" name="header-value"
                        class="form-control form-control-sm" [(ngModel)]="headers.val"
                        [ngModelOptions]="{standalone: true}" [ngbTypeahead]="search"></td>
                    <td style="text-align: center; vertical-align: middle;">
                      <button class="btn btn-sm btn-primary" (click)="addHeaders(headers)" ngbTooltip="Add to list" placement="left"
                      *ngIf="!isEditedHeader">ADD</button>
                      <button class="btn btn-sm btn-primary" (click)="updateFormHeader()" ngbTooltip="Update Header Value" placement="left"
                      *ngIf="isEditedHeader">ADD</button>
                    </td>
                  </tr>
                  <tbody>
                    <tr *ngFor="let item of endpointForm.value.requestHeaders | keyvalue; let i = index">
                      <td name="key">{{item.key}}</td>
                      <td name="value" class="text-break">{{item.value}}</td>
                      <td style="text-align: center; vertical-align: middle;">
                        <i name="delete" class="far fa-trash-alt clickable text-danger"
                          (click)="deleteKeyValueParamsCommon(endpointForm.value.requestHeaders,item.key)"></i>
                        <i name="edit" class="fas fa-edit clickable text-primary" style="margin-left: 5px;"
                          (click)="editFormHeaders(endpointForm.value.requestHeaders, item.key, i)"
                          ngbTooltip="Edit Header Value" placement="left"></i>
                      </td>
                    </tr>
                  </tbody>

                </table>
              </div>
            </div>
            <!-- Bulk edit section -->
            <div *ngIf="headerEditOption === BULK">
              <ngx-codemirror #codemirror id="header-bulk-data" name="header-bulk-data"
                (focusChange)="setEmptyCodemirror('requestHeadersBulk',requestHeadersBulk)"
                [(ngModel)]="requestHeadersBulk" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateBulkParent()"
                [options]="codeMirrorOptions"></ngx-codemirror>
            </div>

          </ng-template>
        </li>
        <li [ngbNavItem]="2" [title]="endpointForm?.value.endPointType.name === 'GRAPHQL' ? 'VARIABLE' : 'PARAMS'" id="2">
          <a ngbNavLink [ngbTooltip]="constants.newEndpointParams">{{endpointForm?.value.endPointType.name === 'GRAPHQL'? 'VARIABLE':'PARAMS'}}</a>
          <ng-template ngbNavContent>
            <div class="mt-3">
              <label for="queryParams">{{endpointForm?.value.endPointType.name === 'GRAPHQL'? 'Graphql Variables':'Query params'}}</label>
              <input type="text" id="queryParams" name="queryParams" class="form-control" [(ngModel)]="queryParams"
                [ngModelOptions]="{standalone: true}" (change)="queryParamsToJson(queryParams)">
              <small id="queryParams" class="form-text text-muted">Ex : Query params in line </small>
            </div>
            <div class="mt-3">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio"
                  (change)="changeEditOptions('paramsEditOption','requestParamsBulk','requestParams')"
                  [(ngModel)]="paramsEditOption" [ngModelOptions]="{standalone: true}" name="inlineRadioOptions"
                  id="inlineRadio2" value="keyval">
                <label class="form-check-label" for="inlineRadio2" [ngbTooltip]="constants.newEndpointParamsKey">Key value</label>
              </div>

              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio"
                  (change)="changeEditOptions('paramsEditOption','requestParamsBulk','requestParams')"
                  [(ngModel)]="paramsEditOption" [ngModelOptions]="{standalone: true}" name="inlineRadioOptions"
                  id="inlineRadio1" value="bulk">
                <label class="form-check-label" for="inlineRadio1" [ngbTooltip]="constants.newEndpointParamsBulk">Bulk</label>
              </div>
              <hr>
            </div>
            <div class="mt-3">
              <!-- Key value section -->
              <div *ngIf="paramsEditOption === KEYVAL">
                <table class="table table-bordered table-sm">
                  <thead class="thead-dark">
                    <tr>
                      <th>Key</th>
                      <th>Value</th>
                      <th width="5%"></th>
                    </tr>
                  </thead>
                  <tr>
                    <td><input type="text" id="param-key" name="param-key" placeholder="Enter key"
                        class="form-control form-control-sm" [(ngModel)]="params.key"
                        [ngModelOptions]="{standalone: true}"></td>
                    <td><input type="text" id="param-value" name="param-value" placeholder="Enter values"
                        class="form-control form-control-sm" [(ngModel)]="params.val"
                        [ngModelOptions]="{standalone: true}"></td>
                    <td style="text-align: center; vertical-align: middle;">
                      <button class="btn btn-sm btn-primary" (click)="addParams(params)" ngbTooltip="Add to list" placement="left"
                      *ngIf="!isEditedParam">ADD</button>
                      <button class="btn btn-sm btn-primary" (click)="updateFormParam()" ngbTooltip="Update Param Value" placement="left"
                      *ngIf="isEditedParam">ADD</button>
                    </td>
                  </tr>
                  <tbody>
                    <tr *ngFor="let item of endpointForm.value.requestParams | keyvalue; let i = index">
                      <td name="key">{{item.key}}</td>
                      <td name="value" class="text-break">{{item.value}}</td>
                      <td style="text-align: center; vertical-align: middle;">
                        <i name="delete" class="far fa-trash-alt clickable text-danger"
                          (click)="deleteKeyValueParamsCommon(endpointForm.value.requestParams, item.key)"></i>
                          <i name="edit" class="fas fa-edit clickable text-primary" style="margin-left: 5px;"
                          (click)="editFormParam(endpointForm.value.requestParams, item.key, i)"
                          ngbTooltip="Edit Param Value" placement="left"></i>
                      </td>
                    </tr>
                  </tbody>

                </table>
              </div>
              <!-- Bulk edit section -->
              <div *ngIf="paramsEditOption === BULK">
                <ngx-codemirror #codemirror id="param-bulk-data" name="param-bulk-data"
                (focusChange)="setEmptyCodemirror('requestParamsBulk',requestParamsBulk)"
                [(ngModel)]="requestParamsBulk" [ngModelOptions]="{standalone: true}"
                (ngModelChange)="updateRequestBulkParent()"
                [options]="codeMirrorOptions"></ngx-codemirror>
              </div>
            </div>
          </ng-template>
        </li>

        <li [title]="endpointForm?.value.endPointType.name === 'GRAPHQL' ? 'QUERY' : 'BODY'" id="3" [ngbNavItem]="3"
          *ngIf="endpointForm.value.requestType === 'POST' || endpointForm.value.requestType === 'PUT' || endpointForm.value.requestType === 'PATCH' || endpointForm.value.requestType === 'DELETE' ">
          <a ngbNavLink [ngbTooltip]="constants.newEndpointBody">{{endpointForm?.value.endPointType.name === 'GRAPHQL'? 'QUERY':'BODY'}}</a>
          <ng-template ngbNavContent>
            <!-- Body type edit options section -->
            <div class="mt-3" *ngIf="endpointForm?.value.endPointType.name !== 'GRAPHQL'">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" [(ngModel)]="bodyTypeEditOption"
                  [ngModelOptions]="{standalone: true}" name="inlineRadioOptions3" id="body1" [value]="FORMDATA"
                  (click)="bodyTypeEditOptionData('FORM-DATA')">
                <label class="form-check-label" for="body1" [ngbTooltip]="constants.newEndpointFormdata">form-data</label>
              </div>

              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" [(ngModel)]="bodyTypeEditOption"
                  [ngModelOptions]="{standalone: true}" name="inlineRadioOptions3" id="body2" [value]="RAW"
                  (click)="bodyTypeEditOptionData('RAW')">
                <label class="form-check-label" for="body2" [ngbTooltip]="constants.newEndpointRaw">raw</label>
              </div>

              <div class="form-check form-check-inline" *ngIf="projectConfiguration !== 'PLAYWRIGHT'">
                <input class="form-check-input" type="radio" [(ngModel)]="bodyTypeEditOption"
                  [ngModelOptions]="{standalone: true}" name="inlineRadioOptions3" id="body3" [value]="MULTIPART"
                  (click)="bodyTypeEditOptionData('MULTIPART')">
                <label class="form-check-label" for="body3" [ngbTooltip]="constants.newEndpointMultipart">multipart</label>
              </div>

              <div class="form-check form-check-inline" *ngIf="projectConfiguration !== 'PLAYWRIGHT'">
                <input class="form-check-input" type="radio" [(ngModel)]="bodyTypeEditOption"
                  [ngModelOptions]="{standalone: true}" name="inlineRadioOptions3" id="body4" [value]="BINARY"
                  (click)="bodyTypeEditOptionData('BINARY')">
                <label class="form-check-label" for="body4" [ngbTooltip]="constants.newEndpointBinary">binary</label>
              </div>
              <hr>
            </div>
            <div class="mt-3" *ngIf="endpointForm?.value.endPointType.name === 'GRAPHQL'">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" [(ngModel)]="bodyTypeEditOption"
                  [ngModelOptions]="{standalone: true}" name="inlineRadioOptions3" id="body5" [value]="GRAPHQL"
                  (click)="bodyTypeEditOptionData('GRAPHQL')">
                <label class="form-check-label" for="body2">GraphQL</label>
              </div>

              <hr>
            </div>

            <!-- Form data section starts here -->
            <div class="mt-3" *ngIf="bodyTypeEditOption === FORMDATA">
              <!-- Key value section -->
              <div>
                <div class="mt-3 text-right">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio"
                      (change)="changeEditOptions('formParamsEditOption','bodyFormDataBulk','formParams')"
                      [(ngModel)]="formParamsEditOption" [ngModelOptions]="{standalone: true}" name="fromdata"
                      id="fromdata1" [value]="KEYVAL">
                    <label class="form-check-label" for="fromdata1" [ngbTooltip]="constants.newEndpointFormdataKeyvalue">Key Value</label>
                  </div>

                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio"
                      (change)="changeEditOptions('formParamsEditOption','bodyFormDataBulk','formParams')"
                      [(ngModel)]="formParamsEditOption" [ngModelOptions]="{standalone: true}" name="fromdata"
                      id="fromdata2" [value]="BULK">
                    <label class="form-check-label" for="fromdata2" [ngbTooltip]="constants.newEndpointFormdataBulk">Bulk</label>
                  </div>
                </div>
                <div *ngIf="formParamsEditOption === KEYVAL" class="mt-2">
                  <table class="table table-bordered table-sm">
                    <thead class="thead-dark">
                      <tr>
                        <th>Key</th>
                        <th>Value</th>
                        <th width="5%"></th>
                      </tr>
                    </thead>
                    <tr>
                      <td><input type="text" placeholder="Enter key" class="form-control form-control-sm"
                          [(ngModel)]="formParams.key" [ngModelOptions]="{standalone: true}"></td>
                      <td><input type="text" placeholder="Enter values" class="form-control form-control-sm"
                          [(ngModel)]="formParams.val" [ngModelOptions]="{standalone: true}"></td>
                      <td style="text-align: center; vertical-align: middle;">
                      <button class="btn btn-sm btn-primary" (click)="addFormParams(formParams)" ngbTooltip="Add to list" placement="left"
                      >ADD</button>
                      </td>
                    </tr>
                    <tbody>
                      <tr *ngFor="let item of endpointForm.value.formParams | keyvalue; let i = index">
                        <td>{{item.key}}</td>
                        <td class="text-break">{{item.value}}</td>
                        <td style="text-align: center; vertical-align: middle;">
                          <i class="far fa-trash-alt clickable text-danger"
                            (click)="deleteKeyValueParamsCommon(endpointForm.value.formParams, item.key)"></i>
                          <i class="fas fa-edit clickable text-primary" style="margin-left: 5px;"
                            (click)="editFormParams(endpointForm.value.formParams, item.key, i)"
                            ngbTooltip="Edit Form Value" placement="left"></i>
                        </td>
                      </tr>
                    </tbody>

                  </table>
                </div>
                <div *ngIf="formParamsEditOption === BULK">
                  <ngx-codemirror #codemirror (focusChange)="setEmptyCodemirror('bodyFormDataBulk',bodyFormDataBulk)"
                    [(ngModel)]="bodyFormDataBulk" [ngModelOptions]="{standalone: true}" (change)="updateBodyFormDataBulkParent()"
                    [options]="codeMirrorOptions"></ngx-codemirror>
                </div>
              </div>

              <!-- Bulk edit section -->
              <div *ngIf="bodyTypeEditOption === RAW">
                <ngx-codemirror #codemirror (focusChange)="setEmptyCodemirror('bodyBulk',bodyBulk)"
                  [(ngModel)]="bodyBulk" [ngModelOptions]="{standalone: true}"
                  [options]="codeMirrorOptions"></ngx-codemirror>
              </div>
            </div>

            <!-- RAW section starts here -->
            <div class="mt-3" *ngIf="bodyTypeEditOption === RAW">
              <ngx-codemirror #codemirror formControlName="requestBody" [options]="codeMirrorOptions"></ngx-codemirror>
            </div>

            <!-- MULTIPART section starts here -->
            <div class="mt-3" *ngIf="bodyTypeEditOption === MULTIPART && projectConfiguration !== 'PLAYWRIGHT'">
              <table class="table table-bordered table-sm" formGroupName="multiPartFormData">
                <tr class="thead-dark">
                  <th>Key</th>
                  <th>Content type</th>
                  <th colspan="2" width="50%">Value</th>
                </tr>
                <tr>
                  <td>
                    <input placeholder="key" class="form-control form-control-sm" [(ngModel)]="multipart.key"
                      [ngModelOptions]="{standalone: true}">
                  </td>
                  <td>
                    <ng-select [attr.data-items]="customHeadersValues" [attr.data-locator]="'content-type'"
                      [attr.data-value]="multipart.contentType" class="custom-style" [items]="customHeadersValues"
                      id="custom-header" bindLabel="name" placeholder="Select" [searchable]="true"
                      [(ngModel)]="multipart.contentType" [ngModelOptions]="{standalone: true}">
                      <ng-option [value]="">Select</ng-option>
                    </ng-select>
                  </td>
                  <td>
                    <textarea [(ngModel)]="multipart.value" [ngModelOptions]="{standalone: true}"
                      class="form-control form-control-sm"></textarea>
                  </td>
                  <td style="text-align: center; vertical-align: middle;">
                      <button class="btn btn-sm btn-primary" (click)="addMulitpart(multipart)" ngbTooltip="Add to list"
                        placement="left">ADD</button>
                  </td>
                </tr>
                <tr *ngFor="let item of endpointForm.value.multiPartFormData.formDataParts;let i = index"
                  class="text-truncate">
                  <td name="key">{{item.key}}</td>
                  <td name="contentType">{{item.contentType}}</td>
                  <td name="value" class="text-break text-wrap">{{item.value}}</td>
                  <td style="text-align: center; vertical-align: middle;">
                    <i class="far fa-trash-alt clickable text-danger" id="delete-multipart-{{i}}"
                      (click)="deleteKeyValueParamsCommon(endpointForm.value.multiPartFormData.formDataParts, item.key, 'multipart', i)"></i>
                    <i class="fas fa-edit clickable text-primary" style="margin-left: 5px;" id="delete-multipart-{{i}}"
                      (click)="editKeyValueParamsCommon(endpointForm.value.multiPartFormData.formDataParts, item.key, 'multipart', i)"></i>
                  </td>
                </tr>
              </table>
            </div>

            <div class="mt-3" *ngIf="bodyTypeEditOption === BINARY && projectConfiguration !== 'PLAYWRIGHT'">
              <table class="table table-bordered table-sm" formGroupName="binaryData">
                <tr class="thead-dark">
                  <th width="15%">Key</th>
                  <th>Value</th>
                  <th *ngIf="endpointForm.value.binaryData.divideFileIntoChunks">
                    chunks <span class="error-msg">*</span>
                  </th>
                </tr>
                <tr>
                  <td>
                    <input placeholder="key" class="form-control-sm" formControlName="key">
                  </td>
                  <td>
                    <textarea cols="30" rows="2" formControlName="value"
                      class="form-control form-control-sm"></textarea>
                    <div class="form-check mt-1">
                      <input class="form-check-input" type="checkbox" id="divide-chunks"
                        formControlName="divideFileIntoChunks">
                      <label class="form-check-label" for="divide-chunks"> divide file into chunks</label>
                    </div>
                  </td>
                  <td *ngIf="endpointForm.value.binaryData.divideFileIntoChunks">
                    <input placeholder="chunkSize" class="form-control form-control-sm" formControlName="chunkSize">
                  </td>
                </tr>
              </table>
            </div>
            <div *ngIf="bodyTypeEditOption === GRAPHQL">
              <textarea placeholder="Enter Query" rows="10" cols="150" formControlName="graphQLParams" class="custom-textarea">

              </textarea>
            </div>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>
  </div>

</form>